import React, { useState } from 'react';
import DataTable, { Alignment } from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../../helpers/formatDate';
import { IconEdit, IconTrash, IconZoomIn, IconEye } from '@tabler/icons-react';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { numberToDate } from '../../../helpers/numberToDate';

const DatatableRiskRegisterComp = (props) => {
  // console.log(props);

  const containerStyle = {
    whiteSpace: 'pre-wrap', // Ini yang paling penting
  };

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };
  const columns = [
    {
      name: 'Aksi',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-outline-warning"
            type="button"
            title="Edit Register Risiko"
            onClick={() => props.handleEditRiskRegister(row)}
          >
            <IconEdit stroke={2} />
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            type="button"
            title="Hapus Register Risiko"
            onClick={() => props.handleHapusRiskRegister(row.id)}
          >
            <IconTrash stroke={2} />
          </button>
          {/* {props.role === 'Administrator' ||
          props.role === 'Kelompok Kerja' ||
          props.role === 'Surveior Internal' ? (
            <>
              <button
                className="btn btn-sm btn-outline-primary"
                type="button"
                title="Detil Register Risiko"
                onClick={() => props.handleLihatRiskRegister(row)}
              >
                <IconEye stroke={2} />
              </button>
            </>
          ) : (
            ''
          )} */}
        </>
      ),
    },
    // {
    //   name: 'Nama Kegiatan',
    //   minWidth: '200px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
    //       {props?.detailriskActivity?.name}
    //     </div>
    //   ),
    //   style: {
    //     // You can also add more styles here
    //     whiteSpace: 'normal',
    //   },
    // },
    // {
    //   name: 'Tujuan Kegiatan',
    //   minWidth: '250px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
    //       {props?.detailriskActivity?.goals}
    //     </div>
    //   ),
    //   style: {
    //     // You can also add more styles here
    //     whiteSpace: 'normal',
    //   },
    // },
    {
      name: 'Tanggal Dibuat',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{ whiteSpace: 'normal', textAlign: 'center', width: '100%' }}
          >
            {numberToDate(row.createdAt)}
          </div>
        </>
      ),
    },
    {
      name: 'Area/Lokasi',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={
              containerStyle
            }
          >
            {row.area}
          </div>
        </>
      ),
    },
    {
      name: 'Sebab',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={containerStyle}>
            {row.causeOfTheIncident}
          </div>
        </>
      ),
    },
    {
      name: 'Kode Risiko',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            R.{row.codeRisk}
          </div>
        </>
      ),
    },
    {
      name: 'Risiko',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={
            containerStyle
          }>
            {row.risk}
          </div>
        </>
      ),
    },
    {
      name: 'Dampak Risiko',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={
            containerStyle
          }>
            {row.impact}
          </div>
        </>
      ),
    },
    {
      name: 'Pernyataan Risiko',
      minWidth: '300px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={
            containerStyle
          }>
            <b>{row.riskStatement}</b>
          </div>
        </>
      ),
    },
    {
      name: 'Pengendalian yang sudah ada',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={
            containerStyle
          }>
            {row.existingControl}
          </div>
        </>
      ),
    },
    {
      name: 'Probabilitas',
      minWidth: '175px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ textAlign: 'center', width: '100%' }}>
            {row.probabilityAnalysis}
            {/* {row.probabilityAnalysis === '1' ? (
              <span className="badge badge-primary text-black">1</span>
            ) : row.probabilityAnalysis === '2' ? (
              <span className="badge badge-success text-black">2</span>
            ) : row.probabilityAnalysis === '3' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'yellow' }}
              >
                3
              </span>
            ) : row.probabilityAnalysis === '4' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'orange' }}
              >
                4
              </span>
            ) : row.probabilityAnalysis === '5' ? (
              <span className="badge badge-danger text-black">5</span>
            ) : (
              ''
            )} */}
          </div>
        </>
      ),
    },
    {
      name: 'Dampak',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ textAlign: 'center', width: '100%' }}>
            {row.impactAnalysis}
            {/* {row.impactAnalysis === '1' ? (
              <span className="badge badge-primary text-black">1</span>
            ) : row.impactAnalysis === '2' ? (
              <span className="badge badge-success text-black">2</span>
            ) : row.impactAnalysis === '3' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'yellow' }}
              >
                3
              </span>
            ) : row.impactAnalysis === '4' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'orange' }}
              >
                4
              </span>
            ) : row.impactAnalysis === '5' ? (
              <span className="badge badge-danger text-black">5</span>
            ) : (
              ''
            )} */}
          </div>
        </>
      ),
    },
    {
      name: 'Bobot',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.bobotAnalysis}
          </div>
        </>
      ),
    },
    {
      name: 'Nilai',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.scoreAnalysis}
          </div>
        </>
      ),
    },
    {
      name: 'Tingkat Risiko',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.riskRating === 'Sangat Rendah' ? (
              <span className="badge badge-primary text-white">
                Sangat Rendah
              </span>
            ) : row.riskRating === 'Rendah' ? (
              <span className="badge badge-success text-white">Rendah</span>
            ) : row.riskRating === 'Sedang' ? (
              <span
                className="badge text-white"
                style={{ backgroundColor: 'yellow' }}
              >
                Sedang
              </span>
            ) : row.riskRating === 'Tinggi' ? (
              <span
                className="badge text-white"
                style={{ backgroundColor: 'orange' }}
              >
                Tinggi
              </span>
            ) : row.riskRating === 'Sangat Tinggi' ? (
              <span className="badge badge-danger text-white">
                Sangat Tinggi
              </span>
            ) : (
              ''
            )}
          </div>
        </>
      ),
    },
    {
      name: 'Selera Risiko',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.riskAppetite === 'Dalam batas selera risiko' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'yellow' }}
              >
                Dalam batas selera risiko
              </span>
            ) : (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'orange' }}
              >
                Diatas batas selera risiko
              </span>
            )}
          </div>
        </>
      ),
    },
    {
      name: 'Penanganan Risiko',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.riskEvaluation === 'Menerima risiko' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'yellow' }}
              >
                Menerima risiko
              </span>
            ) : (
              <span className="badge badge-danger text-black">
                Mitigasi risiko
              </span>
            )}
          </div>
        </>
      ),
    },
    {
      name: 'Opsi Teknik Pengendalian Risiko',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ textAlign: 'center', width: '100%' }}>
            {row.riskControl === '1'
              ? 'Preventive (Pencegahan)'
              : row.riskControl === '2'
                ? 'Reduction (Reduksi)'
                : row.riskControl === '3'
                  ? 'Accept (Terima)'
                  : row.riskControl === '4'
                    ? 'Contigency (Alternatif)'
                    : row.riskControl === '5'
                      ? 'Transfer (Pengalihan)'
                      : ''}
          </div>
        </>
      ),
    },
    {
      name: 'Uraian Penanganan Risiko',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={
            containerStyle
          }>
            {row.riskManagement}
          </div>
        </>
      ),
    },
    {
      name: 'Pembiayaan Risiko',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.riskFinancing}
          </div>
        </>
      ),
    },
    {
      name: 'Probabilitas Residual',
      minWidth: '175px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ textAlign: 'center', width: '100%' }}>
            {/* {row.probabilityResidual} */}
            {row.probabilityResidual === 'Jarang' ? (
              1
            ) : row.probabilityResidual === 'Kemungkinan Kecil' ? (
              2
            ) : row.probabilityResidual === 'Kemungkinan Sedang' ? (
              3
            ) : row.probabilityResidual === 'Kemungkinan Besar' ? (
              4
            ) : row.probabilityResidual === 'Hampir Pasti Terjadi' ? (
              5
            ) : (
              <span className="badge badge-danger text-white">
                belum ada data!
              </span>
            )}
          </div>
        </>
      ),
    },
    {
      name: 'Dampak Residual',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ textAlign: 'center', width: '100%' }}>
            {/* {row.impactResidual} */}
            {row.impactResidual === 'Tidak Signifikan' ? (
              1
            ) : row.impactResidual === 'Kecil' ? (
              2
            ) : row.impactResidual === 'Sedang' ? (
              3
            ) : row.impactResidual === 'Besar' ? (
              4
            ) : row.impactResidual === 'Katastropik' ? (
              5
            ) : (
              <span className="badge badge-danger text-white">
                belum ada data!
              </span>
            )}
          </div>
        </>
      ),
    },
    {
      name: 'Nilai Residual',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row.scoreResidual}
          </div>
        </>
      ),
    },
    {
      name: 'Tingkat Residual',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ textAlign: 'center', width: '100%' }}>
            {row.ratingResidual === 'Sangat Rendah' ? (
              <span className="badge badge-primary text-black">
                Sangat Rendah
              </span>
            ) : row.ratingResidual === 'Rendah' ? (
              <span className="badge badge-success text-black">Rendah</span>
            ) : row.ratingResidual === 'Sedang' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'yellow' }}
              >
                Sedang
              </span>
            ) : row.ratingResidual === 'Tinggi' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'orange' }}
              >
                Tinggi
              </span>
            ) : row.ratingResidual === 'Sangat Tinggi' ? (
              <span className="badge badge-danger text-black">
                Sangat Tinggi
              </span>
            ) : (
              <span className="badge badge-danger text-white">
                belum ada data!
              </span>
            )}
          </div>
        </>
      ),
    },
    {
      name: 'Pemilik Risiko',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {props?.detailriskActivity?.user?.jabatan}
            {''} {props?.detailriskActivity?.user?.risk_division?.namaDivision}
          </div>
        </>
      ),
    },
    {
      name: 'Target Waktu',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {formatDate(row.targetTime)}
          </div>
        </>
      ),
    },
  ];

  const customStyles = {
    rows: {
      style: {
        borderBottom: '1px solid #ddd', // Garis bawah pada setiap baris
      },
    },
    headCells: {
      style: {
        borderBottom: '2px solid #ccc', // Garis bawah yang lebih tebal pada header
        backgroundColor: '#0d6efd', // Warna latar belakang header
        fontWeight: 'bold', // Membuat teks header lebih tegas
        textAlign: 'center', // Rata tengah teks
        justifyContent: 'center', // Pusatkan konten secara horizontal
        color: '#FFFF',
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #ddd', // Garis pemisah antar kolom
        padding: '10px', // Padding agar lebih rapi
      },
    },
  };

  return (
    <>
      <div style={{ overflowX: 'auto', maxWidth: '1200px' }}>
        <DataTable
          columns={columns}
          data={props?.riskRegister}
          customStyles={customStyles}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Cari Register Risiko"
              className="w-50 form-control m-3"
              values={props.search}
              onChange={(e) => props.handleChangeSearch(e.target.value)}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatableRiskRegisterComp;
